<template>
  <div class="contact-details">
    <div class="contact-details--information">
      <span v-if="typeDisplay" class="contact-details--type">
        {{typeDisplay}}
      </span>
      <p v-if="fullName" class="contact-details--fullname">
        {{fullName}}
      </p>

      <template v-if="!editing">
        <p v-if="contact.primaryEmail" class="contact-details--email" ref="email">
          {{contact.primaryEmail}}
        </p>
        <p v-if="phoneNumberDisplay" class="contact-details--phone" ref="phone-number">
          {{phoneNumberDisplay}}
        </p>
      </template>
    </div>
    <div v-if="editable" class="contact-details--editor" ref="editor">
      <ButtonCommon
        v-if="!editing"
        class="edit-button"
        flat
        ref="edit-button"
        @click="toggleEditing">
        Edit
      </ButtonCommon>
      <ContactDetailsForm
        v-if="editing"
        :person="contact"
        ref="edit-form"
        @saved="toggleEditing" />
    </div>
  </div>
</template>

<script>
import { Constants } from '@spectorasoftware/homegauge-vue';

import ButtonCommon from '@/components/common/ButtonCommon.vue';
import ContactDetailsForm from '@/components/ContactDetailsForm.vue';

// default object model
const DEFAULT_CONTACT = {
  primaryEmail: '',
  givenName: '',
  homePhone: '',
  familyName: '',
  mobilePhone: '',
  type: '',
  username: '',
  workPhone: '',
};

export default {
  components: {
    ButtonCommon,
    ContactDetailsForm,
  },
  props: {
    contact: {
      type: Object,
      required: true,
      default: () => DEFAULT_CONTACT,
    },
    editable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      editing: false,
    };
  },
  computed: {
    typeDisplay() {
      return this.contact.type === Constants.AccountTypes.CUSTOMER
        ? 'CLIENT'
        : 'AGENT';
    },
    fullName() {
      const nameParts = [];
      const { familyName, givenName } = this.contact;
      if (givenName) {
        nameParts.push(givenName);
      }
      if (familyName) {
        nameParts.push(familyName);
      }

      return nameParts.join(' ');
    },
    phoneNumberDisplay() {
      const { homePhone, mobilePhone, workPhone } = this.contact;
      return mobilePhone || homePhone || workPhone || '';
    },
  },
  methods: {
    toggleEditing() {
      if (this.editable) {
        this.editing = !this.editing;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';
@import '../styles/vars/typography';

.contact-details {
  position: relative;

  p {
    margin-bottom: 0;
    width: calc(100% - 75px);
  }

  &--fullname {
    font-size: 1.286rem;
    padding: 0 0 0.45rem;
  }

  &--type {
    background-color: lighten(desaturate(adjust-hue($theme-color-secondary, 2), 70.73), 44.31);
    color: $theme-color-primary;
    font-size: 0.857rem;
    font-weight: $typography-weight-bold;
    padding: 0.14rem 0.857rem;
    position: absolute;
    right: 0;
    top: 0;
  }

  &--editor {
    padding: 10px 0;
  }
}

.edit-button {
  color: $theme-color-secondary;
  padding: 0;
}
</style>
